module.exports = __webpack_public_path__ + "assets/2764e9195de18cce1db7583a27a2b9ff.svg";